export default {
  accordion: {
    header: {
      identification: {
        en: "Grammar indentification",
        pt: "Identificação da gramática",
      },
      nonRecursive: {
        en: "Initial non recursive",
        pt: "Inicial não recursivo",
      },
      nonContractive: {
        en: "Essential non contractive",
        pt: "Essencialmente não contrátil",
      },
      noChainRules: {
        en: "No chain rules",
        pt: "Sem regras de cadeia",
      },
      onlyTerminals: {
        en: "Only terminals",
        pt: "Apenas terminais",
      },
      onlyReachable: {
        en: "Only reachable",
        pt: "Apenas símbolos alcançáveis",
      },

      cyk: "CYK",

      leftMostDerivation: {
        en: "Left most derivation",
        pt: "Recursão mais a esquerda",
      },
      ambiguity: {
        en: "Ambiguity check",
        pt: "Checar ambiguidade",
      },
      directLeftRecursion: {
        en: "Removal of direct left recursion",
        pt: "Remover recursão direta à esquerda",
      },
      indirectLeftRecursion: {
        en: "Removal of direct and indirect left recursion",
        pt: "Remoção de recursão direta e indireta à esquerda",
      },
      CFGtoPushdown: {
        en: "Convert CFG into pushdown automaton",
        pt: "Converter CFG para autômato de pilha",
      },
      chomsky_Greibach: "Chomsky & Greibach",
      chomsky: "Chomsky",
      greibach: "Greibach",
      passToPass: {
        en: "Pass to Pass",
        pt: "Passo a Passo",
      },
    },
    input: {
      Inputword: {
        en: "Input a word",
        pt: "Digite uma palavra",
      },
      word: {
        en: "Word (Optional)",
        pt: "Palavra (Opcional)",
      },
    },
    response: {
      ambiguity: {
        en: "Not Ambiguity to word",
        pt: "Não há ambiguidade para a palavra",
      },
      impossiblePDA: {
        en:
          "This grammar show impossibilities to convert grammar to pushdown automata.",
        pt:
          "Essa gramática apresenta impossibilidades para conversão de gramática para autômato com pilha.",
      },
    },
    buttonSubmit: {
      en: "GO!",
      pt: "IR!",
    },
  },
  errors: {
    missWord: {
      en: "Miss word",
      pt: "Falta palavra",
    },
    pda: {
      en: "Wasn't possible to transform grammar in pushdown automata.",
      pt: "Não foi possível transformar a gramática para autômato com pilha",
    },
    characterLimitMessage: {
      en: "Character limit allowed: ",
      pt: "Limite de caracteres permitido: ",
    },
  },
};
